import { Injectable } from '@angular/core';
import { MapInfoWindowTemplateEntry } from '../../models/map-info-window-template';

@Injectable({
  providedIn: 'root'
})
export class MapHelperService {
  getInfoWindowHTML(
    mapInfoWindowTemplateEntries: MapInfoWindowTemplateEntry[],
    nativeMap: boolean,
    entryClickHander?: (entry: MapInfoWindowTemplateEntry, params: any) => void,
    entryClickParams?: any
  ) {
    const frame: HTMLElement = document.createElement('div');
    const container: HTMLElement = document.createElement('div');
    container.classList.add('info-window-custom');
    if (nativeMap) {
      container.classList.add('native-map');
    } else {
      container.classList.add('pwa-map');
    }

    if (mapInfoWindowTemplateEntries && mapInfoWindowTemplateEntries.length) {
      mapInfoWindowTemplateEntries.forEach(entry => {
        const entryFrame = this.getEntryHtml(entry);
        if (!entryFrame) {
          return;
        }
        if (entryClickHander) {
          entryFrame.addEventListener('click', () => {
            entryClickHander(entry, entryClickParams);
          });
        }
        container.appendChild(entryFrame);
      });
    }

    frame.appendChild(container);
    return frame;
  }

  private getEntryHtml(entry: MapInfoWindowTemplateEntry) {
    if (!entry || !entry.type) {
      return null;
    }
    const entryFrame: HTMLElement = document.createElement('div');
    switch (entry.type) {
      case 'header':
        entryFrame.innerHTML = `
              ${entry.text}
            `;
        entryFrame.classList.add('header');
        break;
      case 'text':
        entryFrame.innerHTML = `
            ${entry.text}
          `;
        entryFrame.classList.add('text');
        break;
      case 'icon-text':
        entryFrame.innerHTML = `
            <img class="icon" src="${entry.iconUrl}" />
            <a class="text">
              ${entry.text}
            </a>
          `;
        entryFrame.classList.add('icon-text');
        break;
      case 'icon-ref':
        entryFrame.innerHTML = `
            <img class="icon-ref" src="${entry.iconUrl}" />
            <a class="text" href="${entry.href}">
              ${entry.text}
            </a>
          `;
        entryFrame.classList.add('icon-ref');
        break;
      case 'button':
        entryFrame.innerHTML = `
            <ion-button color="primary">
              ${entry.text}
            </ion-button>
          `;
        entryFrame.classList.add('button');
        break;
      default:
        break;
    }
    return entryFrame;
  }

  getMapStyles() {
    return [
      { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }]
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }]
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }]
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#dadada' }]
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }]
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }]
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }]
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#c9c9c9' }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }]
      }
    ];
  }
}
